import { get, post } from './api/http.service';

// Get app log  -  履歴表示ログ取得
export const getAppLog = (params) => {
  return get('/ccs/v1/general/app/log', params);
};

export const logEvent = async (historyCode, cameraId = null) => {
  const payload = { historyCode };
  if (cameraId) {
    payload.cameraId = cameraId;
  }

  try {
    const result = await post('/ccs/v1/general/app/log', payload, () => false);
    return result;
  } catch (error) {
    console.error('Failed to log event:', error);
  }
};
